module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"none\" viewBox=\"0 0 150 150\"><path d=\"M0 0h150v150H0Z\"></path></svg>"